<script setup lang="ts">
const props = defineProps<{
  title?: string
  description?: string
  statusCode?: number
}>();

// NOTE: this may not be best practice,
// but we assume that displaying that means a 404 server response

// https://nuxt.com/docs/api/utils/set-response-status
const event = useRequestEvent();
if (event) setResponseStatus(event, props.statusCode ?? 404);

const { t } = useI18n();
const titleWithDefault = computed(() => {
  return props.title
    ? props.title
    : props.statusCode === 404
      ? t(`core.error.not_found.title`)
      : t(`core.error.generic.title`);
});
const descriptionWithDefault = computed(() => {
  return props.title
    ? props.title
    : props.statusCode === 404
      ? t(`core.error.not_found.description`)
      : t(`core.error.generic.description`);
});
</script>

<template>
  <div class="flex flex-col items-center gap-l py-2xl">
    <picture class="rounded-full size-24 bg-secondary-70 flex items-center justify-center">
      <img
        src="~/assets/images/not-found.svg"
        :alt="titleWithDefault"
        width="46"
        height="46"
      >
    </picture>
    <IadTitle :text="titleWithDefault" />
    <p
      class="max-w-96 text-center text-2xl"
      v-text="descriptionWithDefault"
    />
    <IadBtn
      to="/"
      :text="$t(`core.error.generic.cta`)"
    />
  </div>
</template>
